/**
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'jquery',
	'../common/NonVIPREventTarget'
], function($, NonVIPREventTarget) {

	class InfographicEventTarget extends NonVIPREventTarget {
		constructor (...args) {
			super(...args);
			const options = args[0] || {};
			this.visControl = options.visControl;
			this.view = options.view;
			return this.getAPI();
		}

		/**
		 * Get the array of event targets based on the event.
		 * Event target represents a data point object that corresponds to the event.
		 *
		 * @param event	Event object
		 */
		getEventTargets (event) {
			const node = this._getTargetNode(event);

			//return null on click since no action will be taken for infographic targets
			if(!node || event.type === 'click') {
				return [];
			}

			var $node = $(node);
			if(!this.mouseWithinBoundCheck(event)) {
				return [];
			}
			return this._getTargets(event, $node);
		}

		remove () {
			this.visControl = null;
			this.view = null;
			super.remove();
		}

		_getTargets (event, $node) {
			var targets = [];
			targets.push({
				key: 'label',
				type: 'itemclass',
				source: $node,
				isEdgeSelect: true,
				values: this._getTargetValues(),
				area: 'visualization'
			});

			return targets;
		}

		_getTargetValues () {
			let slots = [];
			let value = this.view.infographicValue;
			if (value) {
				slots.push({ value });
			}
			return slots;
		}
	}
	return InfographicEventTarget;
});
